import { t } from 'services/translation';

export default function createCheckoutValidations(intl) {
  const termsMessage = intl
    ? intl.formatMessage({
        id: 'TERMS_AND_CONDITIONS_SHOULD_BE_ACCEPTED',
        defaultMessage: 'Terms & Conditions should be accepted',
      })
    : t('TERMS_AND_CONDITIONS_SHOULD_BE_ACCEPTED');

  const privacyMessage = intl
    ? intl.formatMessage({
        id: 'PRIVACY_POLICY_SHOULD_BE_ACCEPTED',
        defaultMessage: 'Privacy Policy should be accepted',
      })
    : t('PRIVACY_POLICY_SHOULD_BE_ACCEPTED');

  return {
    first_name: {
      presence: { allowEmpty: false },
    },
    last_name: {
      presence: { allowEmpty: false },
    },
    email: {
      presence: { allowEmpty: false },
      email: true,
    },
    cardholder_first_name: {
      presence: { allowEmpty: false },
    },
    cardholder_last_name: {
      presence: { allowEmpty: false },
    },
    billing_address_line_1: {
      presence: { allowEmpty: false },
    },
    billing_country: {
      presence: { allowEmpty: false },
    },
    billing_city: {
      presence: { allowEmpty: false },
    },
    billing_region: {
      presence: { allowEmpty: false },
    },
    billing_zip_code: {
      presence: { allowEmpty: false },
    },
    waiver_accepted: {
      isChecked: {
        message: `^${termsMessage}`,
      },
    },
    anyroad_privacy_policy: {},
    privacy_policy_accepted: {
      isChecked: {
        message: `^${privacyMessage}`,
      },
    },
    checkout_questions: {
      checkoutQuestions: { fullMessage: false },
    },
    phone: {
      presence: { allowEmpty: false },
    },
    cardNumber: true,
    cardExpiry: true,
    cardCvc: true,
  };
}
